"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleAlertLeft = exports.TitleAlertRight = exports.TitleAlert = exports.CourierLogoImg = exports.CourierLogoFigure = exports.CourierName = exports.VehicleWrapper = exports.LogoWrapper = exports.CourierWrapper = exports.IconClose = exports.TitleExpeditionClass = exports.WrapperAlertLabel = exports.WrapperLabel = exports.Title = exports.TitleWrapper = exports.ModalWrapper = exports.FadingBackground = exports.StyledModal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledReactModal = _interopRequireWildcard(require("styled-react-modal"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var normalFontSize = '1rem';
var tinyFontSize = '0.8rem';

var StyledModal = _styledReactModal["default"].styled(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 30rem;\n  background-color: white;\n  border-radius: 1rem;\n  opacity: ", ";\n  transition: opacity ease 500ms;\n  position: relative;\n"])), function (props) {
  return props.opacity;
});

exports.StyledModal = StyledModal;
var FadingBackground = (0, _styledComponents["default"])(_styledReactModal.BaseModalBackground).withConfig({
  displayName: "ShipmentDetailDialogStyles__FadingBackground",
  componentId: "sc-1houe7q-0"
})(["opacity:", ";transition:opacity ease 200ms;"], function (props) {
  return props.opacity;
});
exports.FadingBackground = FadingBackground;

var ModalWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__ModalWrapper",
  componentId: "sc-1houe7q-1"
})(["width:fit-content;"]);

exports.ModalWrapper = ModalWrapper;

var TitleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__TitleWrapper",
  componentId: "sc-1houe7q-2"
})(["padding:1.2rem 1.2rem 0 1.2rem;"]);

exports.TitleWrapper = TitleWrapper;

var Title = _styledComponents["default"].h1.withConfig({
  displayName: "ShipmentDetailDialogStyles__Title",
  componentId: "sc-1houe7q-3"
})(["color:#3f4f6c;font-size:1.2rem;text-align:", ";display:flex;flex-direction:row;"], function (props) {
  return props.align || 'initial';
});

exports.Title = Title;

var WrapperLabel = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__WrapperLabel",
  componentId: "sc-1houe7q-4"
})(["display:flex;align-items:flex-end;justify-content:space-between;margin-top:0.2rem;padding:0 1.2rem;"]);

exports.WrapperLabel = WrapperLabel;

var WrapperAlertLabel = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__WrapperAlertLabel",
  componentId: "sc-1houe7q-5"
})(["display:flex;align-items:center;justify-content:center;margin-top:0.2rem;background-color:red;margin-left:20px;margin-right:20px;border-radius:5px;border:2px solid red;overflow-x:hidden;"]);

exports.WrapperAlertLabel = WrapperAlertLabel;

var TitleExpeditionClass = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentDetailDialogStyles__TitleExpeditionClass",
  componentId: "sc-1houe7q-6"
})(["color:#4f5d77;font-size:", ";"], tinyFontSize);

exports.TitleExpeditionClass = TitleExpeditionClass;

var IconClose = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentDetailDialogStyles__IconClose",
  componentId: "sc-1houe7q-7"
})(["position:absolute;color:#a4acb8;font-size:1.5rem;font-weigth:bold;top:0;right:0.5rem;cursor:pointer;"]);

exports.IconClose = IconClose;

var CourierWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__CourierWrapper",
  componentId: "sc-1houe7q-8"
})(["display:flex;flex-direction:row;width:100%;padding:0 1.2rem;margin-bottom:0.6rem;margin-top:0.4rem;"]);

exports.CourierWrapper = CourierWrapper;

var LogoWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__LogoWrapper",
  componentId: "sc-1houe7q-9"
})(["max-width:50%;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;width:42%;"]);

exports.LogoWrapper = LogoWrapper;

var VehicleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentDetailDialogStyles__VehicleWrapper",
  componentId: "sc-1houe7q-10"
})(["display:flex;flex-direction:column;align-items:flex-start;width:58%;"]);

exports.VehicleWrapper = VehicleWrapper;

var CourierName = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentDetailDialogStyles__CourierName",
  componentId: "sc-1houe7q-11"
})(["font-size:", ";color:#4f5d77;margin-left:", ";margin-right:", ";"], normalFontSize, function (props) {
  return props.marginLeft || '0.2rem';
}, function (props) {
  return props.marginRight || 'initial';
});

exports.CourierName = CourierName;

var CourierLogoFigure = _styledComponents["default"].figure.withConfig({
  displayName: "ShipmentDetailDialogStyles__CourierLogoFigure",
  componentId: "sc-1houe7q-12"
})(["height:2.4rem;width:2.4rem;border-radius:100%;margin-right:0.1rem;"]);

exports.CourierLogoFigure = CourierLogoFigure;

var CourierLogoImg = _styledComponents["default"].img.withConfig({
  displayName: "ShipmentDetailDialogStyles__CourierLogoImg",
  componentId: "sc-1houe7q-13"
})(["width:100%;height:100%;border-radius:100%;"]);

exports.CourierLogoImg = CourierLogoImg;

var TitleAlert = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentDetailDialogStyles__TitleAlert",
  componentId: "sc-1houe7q-14"
})(["color:#4f5d77;font-size:0.9rem;width:50%;min-width:50%;"]);

exports.TitleAlert = TitleAlert;

var TitleAlertRight = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentDetailDialogStyles__TitleAlertRight",
  componentId: "sc-1houe7q-15"
})(["color:#4f5d77;font-size:0.9rem;width:50%;min-width:50%;background-color:white;padding-right:1.2rem;"]);

exports.TitleAlertRight = TitleAlertRight;

var TitleAlertLeft = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentDetailDialogStyles__TitleAlertLeft",
  componentId: "sc-1houe7q-16"
})(["padding-left:1.2rem;color:white;font-size:0.9rem;width:50%;min-width:50%;"]);

exports.TitleAlertLeft = TitleAlertLeft;